import { Injectable } from '@angular/core';
import { ActivatedRoute, Router  } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class MrsiService {
  public isOpen: boolean = true;
  public isLoading: boolean = false;
  public mrsiEventList:any = [];
  public mrsiQuestionList:any = [];
  public feedbackList:any = [];
  public totalPages:any = 0;
  public event_id:string = '';
  public apiPageCount: any = 1;
  public apiPageCountForFeedback: any = 1;
  public tabType="pending";
  public dataSize = 50;
  public overallFeebackCount:any = 0;
  public questionSearchText:string='';
  public feedbackSearchText:string='';
  public parentEventName:string='';
  public childEventName:string='';
  httpPostOptionsFile = {
    withCredentials: true
  };
  public questionCountDetails = {};
  constructor(private apiRequest: ApiRequestService, public notifier: NotifierService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

    scrollToTop(){
      var ele = document.getElementById('focus-row');
      if (ele) {
        ele.scrollIntoView();
      }
    }

  getEventsApi(){
    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsFile
    return this.apiRequest.request('GET','/mrsi/get-all-events',{},opt);
  }
  
  getMrsiQuestionsApi(id,type,page,data_size,search){
    let opt = {};
    let url = "/mrsi/get-data/question/"+id+"?data_size="+data_size+"&type="+type+"&page="+page;
    if (search && search !="" && search.length >2) {
      url = url + "&search="+search
    }
    opt['httpOptions'] = this.httpPostOptionsFile
    return this.apiRequest.request('GET',url,{},opt);
  }

  getQuestions(page, isRefresh?:boolean){
    if (this.event_id && this.event_id!= '') {
      this.getMrsiQuestionsApi(this.event_id, this.tabType, page, this.dataSize, this.questionSearchText)
      .subscribe((res:any)=>{
        if (res['status'] == 1) {
          if(res && res.result && res.result.count){
            this.questionCountDetails = res.result.count;
          }
          this.apiPageCount = res["result"]['page'];
          if (this.apiPageCount > 1) {
            this.mrsiQuestionList = [...this.mrsiQuestionList,...res["result"]['data']];
          }else{
            this.mrsiQuestionList = res["result"]['data'];
          }
          if(isRefresh){
            this.notifier.notify('success', 'Question refreshed');
          }
          this.scrollToTop();
          // console.log("this.mrsiQuestionList ",res);
        }else{
          this.notifier.notify('error', 'Something went wrong');
        }
      })
    }
  }

  selectEvent(eventObj){
    this.event_id = eventObj['selectedEvent']['id'];
    this.parentEventName = eventObj['parent'];
    this.childEventName = eventObj['selectedEvent']['name'];
    this.router.navigate(['/mrsi/event-list/',this.event_id]);
    
  }

  getFeedbackList(page,isRefresh?:boolean){
    this.getFeedbackApi(page,this.feedbackSearchText)
    .subscribe((res:any) =>{
      if (res["status"]== 1) {
        if(res && res.result && res.result.count && res.result.count.total){
          this.overallFeebackCount = res.result.count.total;
        }
        if(res && res.result && res.result.total_page){
          this.totalPages = +res.result.total_page;
        }
        this.apiPageCountForFeedback = +res['result']['page'];
        if (this.apiPageCountForFeedback > 1) {
          this.feedbackList = [...this.feedbackList,...res['result']['data']];
        }else{
          this.feedbackList = [];
          this.feedbackList = res['result']['data'];
        }
        if(isRefresh){
          this.notifier.notify('success', 'Feedback refreshed');
          this.scrollToTop();
        }
      }else{
        this.notifier.notify("error","Something went wrong")
      }
    },error=>{
      this.notifier.notify("error","Something went wrong")
    })
  }

  getFeedbackApi(page,search){
    let opt = {};
    let url = "/mrsi/get-data/feedback";
    url += "?page="+page+"&data_size="+this.dataSize
    if (search && search !="" && search.length >2) {
      url = url + "&search="+search
    }
    opt['httpOptions'] = this.httpPostOptionsFile
    return this.apiRequest.request('GET',url,{},opt);
  }

  updateQuestionStatus(question_id,question_status){
    let body ={
      id:question_id,
      status:question_status
    }
    this.updateStatusApi(body)
    .subscribe(res =>{
      if (res['status'] == 1) {
        this.notifier.notify("success","Data updated successfully");
        this.getQuestions(1);
      }else{
        this.notifier.notify("error","Something went wrong")
      }
    })
  }

  updateStatusApi(body){
    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsFile
    return this.apiRequest.request('PUT','/mrsi/update-data ',body,opt);
  }


  

}
